import { Component, Input } from '@angular/core';
import { NbIconModule, NbTooltipModule } from '@nebular/theme';

@Component({
    selector: 'app-tooltip-input',
    template: `
    <nb-icon
      [nbTooltip]="message"
      nbTooltipStatus="primary"
      status="primary"
      class="cursor-pointer"
      icon="alert-circle-outline"
    ></nb-icon>
  `,
    standalone: true,
    imports: [NbIconModule, NbTooltipModule]
})
export class InputTooltipComponent {
  @Input() message: string;
}
